import { Button } from "@mui/material"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import { useNavigate } from "react-router-dom"

export default function BackButton({
  to,
  label = "Back",
  sx = {},
  variant = "outlined",
  useTenant = false,
  ...props
}) {
  const navigate = useNavigate()

  const handleClick = () => {
    if (useTenant) {
      const tenantSlug = sessionStorage.getItem("tenant")
      if (tenantSlug) {
        navigate(`/tenant?tenant=${tenantSlug}`)
        return
      }
    }

    if (typeof to === "string") {
      navigate(to)
    } else if (typeof to === "function") {
      to(navigate)
    } else {
      navigate(-1)
    }
  }

  return (
    <Button
      onClick={handleClick}
      startIcon={<ArrowBackIcon />}
      variant={variant}
      sx={{
        mb: 2,
        borderRadius: "12px",
        textTransform: "none",
        fontWeight: 600,
        color: "text.primary",
        borderColor: "divider",
        ...sx,
      }}
      {...props}
    >
      {label}
    </Button>
  )
}
